import { useQuery } from '@tanstack/react-query'
import { usersApi } from '../api/users.api'
import { usersKeys } from './query-keys'

/**
 * List all users. Used by Settings (active-users summary) and any future
 * consumer that needs the unfiltered users list. The existing `UsersPage`
 * (slice 6) continues to use `useFilteredQuery` for its filtered/searchable
 * variant; both hit `/users` but cache against different keys.
 */
export const useUsers = () =>
	useQuery({
		queryKey: usersKeys.users.list(),
		queryFn: usersApi.listUsers,
	})
